module.exports = __webpack_public_path__ + "static/media/google-play.7b17d635.png";